import React, { useState, useEffect, Fragment } from "react";
import styled from "styled-components";
import { Avatar, ConfigProvider } from "antd";
import enUS from "antd/lib/locale/en_US";
import { useIntl } from "react-intl";
import { MenuOutlined } from '@ant-design/icons';
import { BrowserRouter as Router, Route, Routes, useLocation, Link } from "react-router-dom";
import { ProLayout } from "@ant-design/pro-components";
import { CHARITY } from "./constants";
import StyledText from "./components/StyledText";
import dashBoard from "./assets/dashboard.svg";
import search from "./assets/search.svg";
import impact from "./assets/impact.svg";
import organisation from "./assets/organisation.svg";
import engage from "./assets/engage.svg";
import help from "./assets/help.svg";
import profile from "./assets/profile.svg";
import application from "./assets/applications.svg";
import { useIsMobile } from "./utils/utilities";
import Header from "./components/Header";
import IdeasDashboardPage from "./modules/ideasDashboard/DashboardPage";
import CompanyDashBoard from "./modules/companyDashboard/DashboardPage";
import FeedbackDashboardPage from "./modules/feedbackDashboard/DashboardPage";
import CollaborateDashboardPage from "./modules/collaborateDashboard/DashboardPage";
import QuestionsDashboardPage from "./modules/questionsDashboard/DashboardPage";
import SubmissionDashboardPage from "./modules/submissionDashboard/DashboardPage";
import NotFound from "./modules/NotFound.js";
import LoginPage from "./modules/login/LoginPage";
import SignUpPage from "./modules/signup/SignUpPage";
import SignUpRequested from "./modules/signup/SignUpRequested";
import CharityProfileHome from "./modules/profile/charityProfile/charityProfileHome";
import ForgetPassword from "./modules/login/ForgetPassword";
import ProtectedRoute from "./ProtectedRoute";
import CreateProfile from "./modules/profile/companyProfile/CreateProfile";
import CreateProfileStart from "./modules/profile/companyProfile/CreateProfileStart";
import CreateProfileEntity from "./modules/profile/companyProfile/CreateProfileEntity";
import CreateProfileMedia from "./modules/profile/companyProfile/CreateProfileMedia";
import CreateProfileLogo from "./modules/profile/companyProfile/CreateProfileLogo";
import EditMyProfile from "./modules/profile/companyProfile/EditMyProfile";
import MyProfile from "./modules/profile/companyProfile/MyProfile";
import CreatePassword from "./modules/login/CreatePassword";
import CompanyUser from "./modules/profile/companyProfile/CompanyUser";
import CharityUser from "./modules/profile/charityProfile/CharityUser";
import CompanyApplicationDashboard from "./modules/companyInteractions/Dashboard";
import CharityApplicationDashboard from "./modules/charityInteractions/Dashboard";
import CompanyDonation from "./modules/companyDonations/companyDonationTab";
import CharityDonation from "./modules/charityDonations/charityDonationTab";
import CompanyProgramReview from "./modules/companyProgramReview/ProgramReviewTab";
import CharityCreateStart from "./modules/charityCreate/CharityCreateStart";
import CharityCreateName from "./modules/charityCreate/CharityCreateName";
import CharityProjectDescription from "./modules/charityCreate/CharityProjectDescription";
import CharityProjectLocation from "./modules/charityCreate/CharityProjectLocation";
import CharityProjectDates from "./modules/charityCreate/CharityProjectDates";
import CharityRequest from "./modules/charityCreate/CharityRequest";
import CharityImpactProgram from "./modules/charityCreate/CharityImpactProgram";
import CharityImpactOpportunity from "./modules/charityCreate/CharityImpactOpportunity";
import CharityImpactOpportunity2 from "./modules/charityCreate/CharityImpactOpportunity2";
import CharityImpactBeneficiaries from "./modules/charityCreate/CharityImpactBeneficiaries";
import CharityImpactCustomQuestions from "./modules/charityCreate/CharityImpactCustomQuestions";
import CharityAwardCriteria from "./modules/charityCreate/CharityAwardCriteria";
import CharityAdminDetails from "./modules/charityCreate/CharityAdminDetails";
import CharityCreatePreview from "./modules/charityCreate/charityReview/CharityCreateReviewTab";
import CharityIndicator from "./modules/charityCreate/CharityIndicator";
import ProgrammesList from "./modules/companyCreate/Programmes";
import CompanyCreateStart from "./modules/companyCreate/CompanyCreateStart";
import CompanyCreateName from "./modules/companyCreate/CompanyCreateName";
import CompanyCreateLocation from "./modules/companyCreate/CompanyCreateLocation";
import CompanyCreateDetails from "./modules/companyCreate/CompanyCreateDetails";
import CompanySupport from "./modules/companyCreate/CompanySupport";
import CompanyTimeline from "./modules/companyCreate/CompanyTimeline";
import CompanyEntities from "./modules/companyCreate/CompanyEntities";
import CompanyApplicationQuestion from "./modules/companyCreate/CompanyApplicationQuestion";
import CompanyImpactStrategy from "./modules/companyCreate/CompanyImpactStrategy";
import CompanyMeasuringImpact from "./modules/companyCreate/CompanyMeasuringImpact";
import CompanyMeasuringApproval from "./modules/companyCreate/CompanyMeasuringApproval";
import CompanyCreateAdmin from "./modules/companyCreate/CompanyCreateAdmin";
import CompanyCreatePreview from "./modules/companyCreate/companyReview/CompanyCreateReviewTab";
import CharityApplicationCreatePreview from "./modules/charityCreate/charityReview/CharityApplicationCreateReviewTab";
import CharityProgramReviewTab from "./modules/charityCreate/charityProgramReview/ProgramReviewTab";
import CompanyProgramReviewTab from "./modules/companyCreate/companyProgramReview/CompanyProgramReviewTab";
import CharityProfileCreateStart from "./modules/charityProfileCreate/CharityProfileCreateStart";
import CharityEntityName from "./modules/charityProfileCreate/CharityEntityName";
import CharityProfileLegalStructure from "./modules/charityProfileCreate/CharityProfileLegalStructure";
import CharityProfileTrustees from "./modules/charityProfileCreate/CharityProfileTrustees";
import CharityProfileLocations from "./modules/charityProfileCreate/CharityProfileLocation";
import CharityProfileDescription from "./modules/charityProfileCreate/CharityProfileDescription";
import CharityProfileMedia from "./modules/charityProfileCreate/CharityProfileMedia";
import CharityProfilePreview from "./modules/charityProfileCreate/CharityProfilePreview";
import CharityProfileReview from "./modules/charityProfileCreate/CharityProfileReview";
import CharityProfileEnd from "./modules/charityProfileCreate/CharityProfileEnd";
import CharityDiscoverFundingOpportunities from "./modules/charityProfileCreate/CharityDiscoverFundingOpportunities";
import CharityContent from "./modules/charityProfileCreate/CharityContent";
import CompanyContent from "./modules/charityProfileCreate/CompanyContent";
import CharityInterimCreateStart from "./modules/charityInterimContent/CharityInterimCreateStart";
import CharityInterimCreateReport from "./modules/charityInterimContent/CharityInterimCreateReport";
import CharityInterimCreatePreview from "./modules/charityInterimContent/CharityInterimCreatePreviewTab";
import CharityFinalCreateStart from "./modules/charityFinalContent/CharityFinalCreateStart";
import CharityFinalCreateInput from "./modules/charityFinalContent/CharityFinalCreateInput";
import CharityFinalCreateOutput from "./modules/charityFinalContent/CharityFinalCreateOutput";
import CharityFinalCreateBeneficiary from "./modules/charityFinalContent/CharityFinalCreateBeneficiary";
import CharityFinalCreateObjectives from "./modules/charityFinalContent/CharityFinalCreateObjectives";
import CharityFinalCreateImpactMeasures from "./modules/charityFinalContent/CharityFinalCreateImpactMeasures";
import CharityFinalCaseStudies from "./modules/charityFinalContent/CharityFinalCaseStudies";
import CharityFinalNextSteps from "./modules/charityFinalContent/CharityFinalNextSteps";
import CharityFinalAdditionalQuestions from "./modules/charityFinalContent/CharityFinalAdditionalQuestions";
import CharityFinalPreview from "./modules/charityFinalContent/CharityFinalCreatePreviewTab";
import CharityInterimCreateReview from "./modules/charityInterimContent/CharityInterimCreateReviewTab";
import CharityFinalReview from "./modules/charityFinalContent/CharityFinalCreateReviewTab";
import VerificationComponent from "./modules/verification/VerificationComponent";
import ConfirmationComponent from "./modules/verification/ConfirmationComponent";
import SharePreApproved from "./modules/verification/SharePreApproved";

const getPaddingValue = (props) => {
  return props?.loginPagesPath ? '35px' : 0;
}

const StyledProLayout = styled(ProLayout)`
  padding-block: 0 !important;
  padding-inline: 0 !important;
`;

const StyledMainContainer = styled.div`
  padding-left: ${props => getPaddingValue(props)};
  background: #ffffff;
`;

const urlMappings = {
  "/#/sharable/company/programme/2686aa63-bfc1-4d90-afa8-470dc9e55c38/a170a923617011701883ef7987a4f3ae46d47505e252a112762dd14b8edf4b6cd544f59ff0e8e9ef1bd8b0a9feef01341867bcc1aedc685abe786eca94ecb98f": "/public/langmarken-wind-farm-community-fund",
  "/#/sharable/company/programme/8176c297-149b-4f5b-88c8-d011eeb52a49/e598f686e6941fa0ebfe8ca089a1c3c2a9a5e4d06dc69c523d7b0e2d826025f393ff04aede7d67cc107fa9ed7d8d61af8ff4d55ac763509e627715b82ccc68ff": "/public/piiparinmaki-wind-farm-community-fund",
  "/#/sharable/company/programme//dcf7aa0c06f3a904db121ce5cf514c120dc6686f2144036e48ee3f8adcfd96eabea7c8fa900ff9bac1a2def23aa0d66a5f0bd944fb2a21b9aa49afc5c85948f0": "/public/bockingfold-solar-farm-fund",
  "/#/sharable/company/programme/aff36a55-4abd-4536-bf47-14631c2fdf89/0c8c8ab18d5f8366ee5ca492bd6a53011400b96d1792d946399570487251e16d6535b4be8cc2c3dd78bf6847be8d3403953cd04d95d44457a6a0d8cdf3735b95": "/public/watchman-small-grants",
  "/#/sharable/company/programme/0d00a008-d7c2-4dc6-9b89-2e800c934289/2ec2cd6b80b6c6611929914da0654b24de2b7756fcd00c7ebe4309930adc19b59cefff91979874195ae273cdda5cc352d25e68c2dee3977420c4d20e075702e6": "/public/saunamaa-suolakangas-wind-farms-community-fund",
  "/#/sharable/company/programme/630b8ffd-a08d-4cfc-900a-9c57a2c704f7/8a267c3af15a26c8fb30359e57295e35f3e6ace3e2424b3fcbd8970c65410b58ca58cb51bf672af3d94eafbe46f9d882a8fc7cf0df4e22d2638aca2f27dc497d": "/public/orit-impact-fund",
  "/#/sharable/company/programme/cb1e5eed-9e08-41df-a644-b2882f12b1f4/63d776c00d0450b8d34ad9fad4c48d82281e9fd72b8f9c2e11040d6743612ae3b87231cfcaf6c0cd10dcd8285a0006470315492f9388d9023201551036272fe1": "/public/nextenergy-uk-esg-solar-impact-fund",
  "/#/sharable/company/programme/f1a970db-5eca-446e-b0ee-b24b36dcd38f/e7338a2848196fafd58ab701949a6285dfdfcea94dfcfc82ed1d58bc1179850fc5043e72c58cb1b7a8a55b99ddea2d3fb167f6e401f449d514fffb3239ff8129": "/public/nextenergy-east-england-solar-impact-fund",
  "/#/sharable/company/programme/g2a970db-5eca-446e-b0ee-b24b36dcd38f/e7338a2848196fafd58ab701949a6285dfdfcea94dfcfc82ed1d58bc1179850fc5043e72c58cb1b7a8a55b99ddea2d3fb167f6e401f449d514fffb3239ff8129": "/public/nextenergy-south-east-england-solar-impact-fund",
  "/#/sharable/company/programme/e0a970db-5eca-446e-b0ee-b24b36dcd38f/e7338a2848196fafd58ab701949a6285dfdfcea94dfcfc82ed1d58bc1179850fc5043e72c58cb1b7a8a55b99ddea2d3fb167f6e401f449d514fffb3239ff8129": "/public/nextenergy-midlands-north-solar-impact-fund",
  "/#/sharable/company/programme/h3a970db-5eca-446e-b0ee-b24b36dcd38f/e7338a2848196fafd58ab701949a6285dfdfcea94dfcfc82ed1d58bc1179850fc5043e72c58cb1b7a8a55b99ddea2d3fb167f6e401f449d514fffb3239ff8129": "/public/nextenergy-sw-england-wales-northern-ireland-solar-impact-fund"
};

const CustomHeader = ({ isMobile, menuCollapsed, setMenuCollapsed }) => {
  return (
    <>
      <div className="mobile-menu">
        <MenuOutlined
          style={{ color: '#04ac9c', fontSize: '24px' }}
          onClick={() => setMenuCollapsed(!menuCollapsed)}
        />
      </div>
      <Header isMobile={isMobile} />
    </>
  );
};

const RootRoute = ({ userType }) => {
  const isMobile = useIsMobile();
  const [menuCollapsed, setMenuCollapsed] = useState(false);
  const [tokenAvailable, setTokenAvailable] = useState(false);
  const [isLoginPagesPath, setIsLoginPagesPath] = useState(false);
  const location = useLocation();
  const intl = useIntl();

  useEffect(() => {
    const isTokenAvailable = window.localStorage.getItem('id_Token');
    const createProfileRoutes = [
      "/",
      "/login",
      "/signup",
      "/forgot-password",
      "/create-password",
      "/signup-requested",
      "/company/profile/create/entity",
      "/company/profile/create/start",
      "/company/profile/create/media",
      "/company/profile/create/logo",
      "/company/my-profile/edit",
      "/impact-maker/applications/create/start",
      "/impact-maker/applications/create/name",
      "/impact-maker/applications/create/description",
      "/impact-maker/applications/create/location",
      "/impact-maker/applications/create/dates",
      "/impact-maker/applications/create/request",
      "/impact-maker/applications/create/impact-programme-custom",
      "/impact-maker/applications/create/impact-opportunity-custom",
      "/impact-maker/applications/create/impact-project-custom",
      "/impact-maker/applications/create/beneficiaries",
      "/impact-maker/applications/create/custom-questions",
      "/impact-maker/applications/create/award-criteria",
      "/impact-maker/applications/create/admin-details",
      "/impact-maker/applications/create/indicators",
      "/impact-maker/applications/create/preview",
      "/company/programme/create/name",
      "/company/programme/create/state",
      "/company/programme/create/location",
      "/company/programme/create/details",
      "/company/programme/create/support",
      "/company/programme/create/timelines",
      "/company/programme/create/entities",
      "/company/programme/create/questions",
      "/company/programme/create/impact",
      "/company/programme/create/measure",
      "/company/programme/create/approval",
      "/company/programme/create/admin",
      "/company/programme/create/preview",
      "/public/",
      "/impact-maker/profile/create/start",
      "/impact-maker/profile/create/entity-name",
      "/impact-maker/profile/create/legal-structure",
      "/impact-maker/profile/create/trustees",
      "/impact-maker/profile/create/locations",
      "/impact-maker/profile/create/description",
      "/impact-maker/profile/create/media",
      "/impact-maker/profile/create/preview",
      "/impact-maker/profile/create/profile-end",
      "/impact-maker/content/interim/start",
      "/impact-maker/content/interim/report",
      "/impact-maker/content/interim/preview",
    ]?.includes(location?.pathname);

    const hiddenSideNavPaths = [
      "/impact-maker/content/interim/start",
      "/impact-maker/content/interim/report",
      "/impact-maker/content/interim/preview",
      "/impact-maker/content/final/start/",
      "/impact-maker/content/final/inputs",
      "/impact-maker/content/final/outputs",
      "/impact-maker/content/final/beneficiaries",
      "/impact-maker/content/final/objectives",
      "/impact-maker/content/final/indicators",
      "/impact-maker/content/final/case-studies",
      "/impact-maker/content/final/next-steps",
      "/impact-maker/content/final/additional-questions",
      "/impact-maker/content/final/preview",
      "/share/verification",
      "/share/confirmation",
      "/share/preapproved"
    ];
    const dynamicPathPatterns = [
      /^\/impact-maker\/content\/[a-f0-9-]+\?type=final$/,
      /^\/company\/applications\/preapproved\/[a-f0-9-]+\/[a-f0-9-]+$/,
    ];

    const shouldHideSideNav =
      hiddenSideNavPaths.some(path => location?.pathname?.startsWith(path)) ||
      dynamicPathPatterns.some(pattern => pattern.test(location?.pathname));
    const showSideNav = !!isTokenAvailable && !createProfileRoutes && !shouldHideSideNav;
    setTokenAvailable(showSideNav);
    setIsLoginPagesPath(createProfileRoutes);
  }, [location]);

  useEffect(() => {
    const currentPath = `${window.location.pathname}${window.location.hash}`;
    const newPath = urlMappings[currentPath];

    if (newPath) {
      window.location.href = `${window.location.origin}${newPath}`;
    }
  }, [location]);

  const locationType = window?.location?.pathname?.includes("impact-maker");

  const charityTypeUser = localStorage.getItem('userType') === CHARITY || userType === CHARITY;

  const route = charityTypeUser || locationType ? `impact-maker` : `company`;

  const CharityMenuItems = [
    {
      path: `${route}/discover`,
      icon: <Avatar src={search} shape="square" />,
      name: (
        <StyledText as="p" variant="B3" className="status">
          {intl.formatMessage({ id: "Discover" })}
        </StyledText>
      ),
      to: `${route}/discover`
    },
    {
      path: "applications",
      icon: <Avatar src={application} shape="square" />,
      name: (
        <StyledText as="p" variant="B3" className="status">
          {intl.formatMessage({ id: "applications" })}
        </StyledText>
      ),
      children: [
        {
          path: `${route}/applications/actions`,
          name: (
            <StyledText as="p" variant="B3" className="status">
              {intl.formatMessage({ id: "action_required" })}
            </StyledText>
          ),
          to: `${route}/applications/actions`,
        },
        {
          path: `${route}/applications/pending`,
          name: (
            <StyledText as="p" variant="B3" className="status">
              {intl.formatMessage({ id: "pending_response" })}
            </StyledText>
          ),
          to: `${route}/applications/pending`,
        },
        {
          path: `${route}/applications/approved`,
          name: (
            <StyledText as="p" variant="B3" className="status">
              {intl.formatMessage({ id: "approved" })}
            </StyledText>
          ),
          to: `${route}/applications/approved`,
        },
        {
          path: `${route}/applications/declined`,
          name: (
            <StyledText as="p" variant="B3" className="status">
              {intl.formatMessage({ id: "declined" })}
            </StyledText>
          ),
          to: `${route}/applications/declined`,
        }
      ],
    },
    {
      path: "impact",
      icon: <Avatar src={impact} shape="square" />,
      name: (
        <StyledText as="p" variant="B3" className="status">
          {intl.formatMessage({ id: "impact" })}
        </StyledText>
      ),
      children: [
        {
          path: `${route}/content`,
          name: (
            <StyledText as="p" variant="B3" className="status">
              {intl.formatMessage({ id: "content" })}
            </StyledText>
          ),
          to: `${route}/content`,
        },
        {
          path: `${route}/donations`,
          name: (
            <StyledText as="p" variant="B3" className="status">
              {intl.formatMessage({ id: "donations" })}
            </StyledText>
          ),
          to: `${route}/donations`,
        }
      ],
    },
    {
      path: `${route}/my-profile`,
      icon: <Avatar src={profile} shape="square" />,
      name: (
        <StyledText as="p" variant="B3" className="status">
          {intl.formatMessage({ id: "my_profile" })}
        </StyledText>
      ),
      to: `${route}/my-profile`,
    },
    {
      path: "organisation",
      icon: <Avatar src={organisation} shape="square" />,
      name: (
        <StyledText as="p" variant="B3" className="status">
          {intl.formatMessage({ id: "organisation" })}
        </StyledText>
      ),
      children: [
        {
          path: `${route}/users`,
          name: (
            <StyledText as="p" variant="B3" className="status">
              {intl.formatMessage({ id: "users" })}
            </StyledText>
          ),
          to: `${route}/users`,
        },
        {
          path: `${route}/profile`,
          name: (
            <StyledText as="p" variant="B3" className="status">
              {intl.formatMessage({ id: "profile" })}
            </StyledText>
          ),
          to: `${route}/profile`,
        }
      ],
    },
    {
      path: "/support",
      icon: <Avatar src={help} shape="square" />,
      name: (
        <StyledText as="p" variant="B3" className="status">
          {intl.formatMessage({ id: "help" })}
        </StyledText>
      ),
      to: "https://bizgive.atlassian.net/servicedesk/customer/portal/2",
      isExternal: true,
    },
  ];

  const CompanyMenuItems = [
    {
      path: `${route}/impact-dashboard`,
      icon: <Avatar src={dashBoard} shape="square" />,
      name: (
        <StyledText as="p" variant="B3" className="status">
          {intl.formatMessage({ id: "dashboard" })}
        </StyledText>
      ),
      to: `${route}/impact-dashboard`,
    },
    {
      path: `${route}/submissions`,
      icon: <Avatar src={engage} shape="square" />,
      name: (
        <StyledText as="p" variant="B3" className="status">
          {intl.formatMessage({ id: "engage" })}
        </StyledText>
      ),
      to: `${route}/submissions`,
    },
    {
      icon: <Avatar src={application} shape="square" />,
      name: (
        <StyledText as="p" variant="B3" className="status">
          {intl.formatMessage({ id: "applications" })}
        </StyledText>
      ),
      children: [
        {
          path: `${route}/applications/actions`,
          name: (
            <StyledText as="p" variant="B3" className="status">
              {intl.formatMessage({ id: "action_required" })}
            </StyledText>
          ),
          to: `${route}/applications/actions`,
        },
        {
          path: `${route}/applications/pending`,
          name: (
            <StyledText as="p" variant="B3" className="status">
              {intl.formatMessage({ id: "pending_response" })}
            </StyledText>
          ),
          to: `${route}/applications/pending`,
        },
        {
          path: `${route}/applications/pre-approved`,
          name: (
            <StyledText as="p" variant="B3" className="status">
              {intl.formatMessage({ id: "pre_approved" })}
            </StyledText>
          ),
          to: `${route}/applications/pre-approved`,
        },
        {
          path: `${route}/applications/approved`,
          name: (
            <StyledText as="p" variant="B3" className="status">
              {intl.formatMessage({ id: "approved" })}
            </StyledText>
          ),
          to: `${route}/applications/approved`,
        },
        {
          path: `${route}/applications/declined`,
          name: (
            <StyledText as="p" variant="B3" className="status">
              {intl.formatMessage({ id: "declined" })}
            </StyledText>
          ),
          to: `${route}/applications/declined`,
        }
      ],
    },
    {
      path: "impact",
      icon: <Avatar src={impact} shape="square" />,
      name: (
        <StyledText as="p" variant="B3" className="status">
          {intl.formatMessage({ id: "impact" })}
        </StyledText>
      ),
      children: [
        {
          path: `${route}/content`,
          name: (
            <StyledText as="p" variant="B3" className="status">
              {intl.formatMessage({ id: "content" })}
            </StyledText>
          ),
          to: `${route}/content`,
        },
        {
          path: `${route}/donations`,
          name: (
            <StyledText as="p" variant="B3" className="status">
              {intl.formatMessage({ id: "donations" })}
            </StyledText>
          ),
          to: `${route}/donations`,
        }
      ],
    },
    {
      path: `${route}/my-profile`,
      icon: <Avatar src={profile} shape="square" />,
      name: (
        <StyledText as="p" variant="B3" className="status">
          {intl.formatMessage({ id: "my_profile" })}
        </StyledText>
      ),
      to: `${route}/my-profile`,
    },
    {
      path: "organisation",
      icon: <Avatar src={organisation} shape="square" />,
      name: (
        <StyledText as="p" variant="B3" className="status">
          {intl.formatMessage({ id: "organisation" })}
        </StyledText>
      ),
      children: [
        {
          path: `${route}/users`,
          name: (
            <StyledText as="p" variant="B3" className="status">
              {intl.formatMessage({ id: "users" })}
            </StyledText>
          ),
          to: `${route}/users`,
        },
        {
          path: `${route}/profile`,
          name: (
            <StyledText as="p" variant="B3" className="status">
              {intl.formatMessage({ id: "profile" })}
            </StyledText>
          ),
          to: `${route}/profile`,
        },
        {
          path: `${route}/programmes`,
          name: (
            <StyledText as="p" variant="B3" className="status">
              {intl.formatMessage({ id: "programmes" })}
            </StyledText>
          ),
          to: `${route}/programmes`,
        },
      ],
    },
    {
      path: "/support",
      icon: <Avatar src={help} shape="square" />,
      name: (
        <StyledText as="p" variant="B3" className="status">
          {intl.formatMessage({ id: "help" })}
        </StyledText>
      ),
      to: "https://bizgive.atlassian.net/servicedesk/customer/portal/2",
      isExternal: true,
    },
  ];

  const searchParams = new URLSearchParams(location.search);
  const type = searchParams.get('type');

  const Container = !/public/.test(location?.pathname) && tokenAvailable
    ? StyledProLayout
    : Fragment;

  return (
    <>
      {!tokenAvailable && <Header isMobile={isMobile} />}
      <ConfigProvider locale={enUS}>
        <Container
          layout="mix"
          style={{ padding: 0 }}
          locale="en-US"
          collapsed={menuCollapsed}
          onCollapse={setMenuCollapsed}
          menuDataRender={() => {
            const items = tokenAvailable && charityTypeUser
              ? CharityMenuItems
              : tokenAvailable
                ? CompanyMenuItems
                : [];

            return items.map((item) => {
              if (item.children) {
                return {
                  ...item,
                  name: item.name,
                  children: item.children.map((child) => ({
                    ...child,
                    name: <Link key={child.path} to={child.path}>{child.name}</Link>,
                  })),
                };
              }
              return {
                ...item,
                name: item.isExternal ? (
                  <a
                    key={item.path}
                    href={item.to}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.name}
                  </a>
                ) : (
                  <Link key={item.path} to={item.path}>{item.name}</Link>
                ),
              };
            });
          }}
          location={{ pathname: location.pathname }}
          headerRender={() => (
            <CustomHeader
              isMobile={isMobile}
              menuCollapsed={menuCollapsed}
              setMenuCollapsed={setMenuCollapsed}
            />
          )}
        >
          <StyledMainContainer className="appMainContainer" menuCollapsed={menuCollapsed} loginPagesPath={isLoginPagesPath}>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/" element={<LoginPage />} />
              <Route path="/signup" element={<SignUpPage />} />
              <Route path="/company/impact-dashboard" element={<ProtectedRoute><CompanyDashBoard /></ProtectedRoute>} />
              <Route path="/signup-requested" element={<SignUpRequested />} />
              <Route path="/charity-profile-home" element={<ProtectedRoute><CharityProfileHome /> </ProtectedRoute>} />
              <Route path="/company-profile-home" element={<ProtectedRoute><CharityProfileHome /></ProtectedRoute>} />
              <Route path="/company/submissions/ideas" element={<ProtectedRoute><IdeasDashboardPage /></ProtectedRoute>} />
              <Route path="/company/submissions/ideas-data" element={<ProtectedRoute><IdeasDashboardPage /></ProtectedRoute>} />
              <Route path="/company/submissions/feedback" element={<ProtectedRoute><FeedbackDashboardPage /></ProtectedRoute>} />
              <Route path="/company/submissions/feedback-data" element={<ProtectedRoute><FeedbackDashboardPage /></ProtectedRoute>} />
              <Route path="/company/submissions/collaborate" element={<ProtectedRoute><CollaborateDashboardPage /></ProtectedRoute>} />
              <Route path="/company/submissions/collaborate-data" element={<ProtectedRoute><CollaborateDashboardPage /></ProtectedRoute>} />
              <Route path="/company/submissions/questions" element={<ProtectedRoute><QuestionsDashboardPage /></ProtectedRoute>} />
              <Route path="/company/submissions" element={<ProtectedRoute><SubmissionDashboardPage /></ProtectedRoute>} />
              <Route path="/company-profile-home" element={<ProtectedRoute><CharityProfileHome /></ProtectedRoute>} />
              <Route path="/company/profile" element={<ProtectedRoute><CreateProfile /></ProtectedRoute>} />
              <Route path="/company/profile/create/entity" element={<ProtectedRoute><CreateProfileEntity /></ProtectedRoute>} />
              <Route path="/company/profile/create/start" element={<ProtectedRoute><CreateProfileStart /></ProtectedRoute>} />
              <Route path="/company/profile/create/media" element={<ProtectedRoute><CreateProfileMedia /></ProtectedRoute>} />
              <Route path="/company/profile/create/logo" element={<ProtectedRoute><CreateProfileLogo /></ProtectedRoute>} />
              <Route path="/company/my-profile/edit" element={<ProtectedRoute><EditMyProfile /></ProtectedRoute>} />
              <Route path="/impact-maker/my-profile/edit" element={<ProtectedRoute><EditMyProfile /></ProtectedRoute>} />
              <Route path="/impact-maker/applications/actions" element={<ProtectedRoute><CharityApplicationDashboard /></ProtectedRoute>} />
              <Route path="/impact-maker/applications/pending" element={<ProtectedRoute><CharityApplicationDashboard /></ProtectedRoute>} />
              <Route path="/impact-maker/applications/approved" element={<ProtectedRoute><CharityApplicationDashboard /></ProtectedRoute>} />
              <Route path="/impact-maker/applications/declined" element={<ProtectedRoute><CharityApplicationDashboard /></ProtectedRoute>} />
              <Route path="/company/applications/:programID?/:opportunityID?" element={<ProtectedRoute><CompanyProgramReviewTab /></ProtectedRoute>} />
              <Route path="/company/applications/preapproved/:programID?/:opportunityID?" element={<ProtectedRoute><CompanyProgramReviewTab /></ProtectedRoute>} />
              <Route path="/company/applications/actions" element={<ProtectedRoute><CompanyApplicationDashboard /></ProtectedRoute>} />
              <Route path="/company/applications/pending" element={<ProtectedRoute><CompanyApplicationDashboard /></ProtectedRoute>} />
              <Route path="/company/applications/pre-approved" element={<ProtectedRoute><CompanyApplicationDashboard /></ProtectedRoute>} />
              <Route path="/company/applications/approved" element={<ProtectedRoute><CompanyApplicationDashboard /></ProtectedRoute>} />
              <Route path="/company/applications/declined" element={<ProtectedRoute><CompanyApplicationDashboard /></ProtectedRoute>} />
              <Route path="/company/my-profile" element={<ProtectedRoute><MyProfile /></ProtectedRoute>} />
              <Route path="/impact-maker/my-profile" element={<ProtectedRoute><MyProfile /></ProtectedRoute>} />
              <Route path="/company/donations" element={<ProtectedRoute><CompanyDonation /></ProtectedRoute>} />
              <Route path="/create-password/:username?" element={<CreatePassword />} />
              <Route path="/company/users" element={<ProtectedRoute><CompanyUser /></ProtectedRoute>} />
              <Route path="/impact-maker/donations" element={<ProtectedRoute><CharityDonation /></ProtectedRoute>} />
              <Route path="/company/programmes/review/:programID?" element={<ProtectedRoute><CompanyProgramReview /></ProtectedRoute>} />
              <Route path="/impact-maker/applications/create/start" element={<ProtectedRoute><CharityCreateStart /></ProtectedRoute>} />
              <Route path="/impact-maker/applications/create/name" element={<ProtectedRoute><CharityCreateName /></ProtectedRoute>} />
              <Route path="/impact-maker/applications/create/description" element={<ProtectedRoute><CharityProjectDescription /></ProtectedRoute>} />
              <Route path="/impact-maker/applications/create/location" element={<ProtectedRoute><CharityProjectLocation /></ProtectedRoute>} />
              <Route path="/impact-maker/applications/create/dates" element={<ProtectedRoute><CharityProjectDates /></ProtectedRoute>} />
              <Route path="/impact-maker/applications/create/request" element={<ProtectedRoute><CharityRequest /></ProtectedRoute>} />
              <Route path="/impact-maker/applications/create/impact-programme-custom" element={<ProtectedRoute><CharityImpactProgram /></ProtectedRoute>} />
              <Route path="/impact-maker/applications/create/impact-opportunity-custom" element={<ProtectedRoute><CharityImpactOpportunity /></ProtectedRoute>} />
              <Route path="/impact-maker/applications/create/impact-project-custom" element={<ProtectedRoute><CharityImpactOpportunity2 /></ProtectedRoute>} />
              <Route path="/impact-maker/applications/create/beneficiaries" element={<ProtectedRoute><CharityImpactBeneficiaries /></ProtectedRoute>} />
              <Route path="/impact-maker/applications/create/custom-questions" element={<ProtectedRoute><CharityImpactCustomQuestions /></ProtectedRoute>} />
              <Route path="/impact-maker/applications/create/indicators" element={<ProtectedRoute><CharityIndicator /></ProtectedRoute>} />
              <Route path="/impact-maker/applications/create/award-criteria" element={<ProtectedRoute><CharityAwardCriteria /></ProtectedRoute>} />
              <Route path="/impact-maker/applications/create/admin-details" element={<ProtectedRoute><CharityAdminDetails /></ProtectedRoute>} />
              <Route path="/impact-maker/applications/create/preview" element={<ProtectedRoute><CharityCreatePreview /></ProtectedRoute>} />
              <Route path="/company/programmes" element={<ProtectedRoute><ProgrammesList /></ProtectedRoute>} />
              <Route path="/company/programme/create/start" element={<ProtectedRoute><CompanyCreateStart /></ProtectedRoute>} />
              <Route path="/company/programme/create/name" element={<ProtectedRoute><CompanyCreateName /></ProtectedRoute>} />
              <Route path="/company/programme/create/location" element={<ProtectedRoute><CompanyCreateLocation /></ProtectedRoute>} />
              <Route path="/company/programme/create/details" element={<ProtectedRoute><CompanyCreateDetails /></ProtectedRoute>} />
              <Route path="/company/programme/create/support" element={<ProtectedRoute><CompanySupport /></ProtectedRoute>} />
              <Route path="/company/programme/create/timelines" element={<ProtectedRoute><CompanyTimeline /></ProtectedRoute>} />
              <Route path="/company/programme/create/entities" element={<ProtectedRoute><CompanyEntities /></ProtectedRoute>} />
              <Route path="/company/programme/create/questions" element={<ProtectedRoute><CompanyApplicationQuestion /></ProtectedRoute>} />
              <Route path="/company/programme/create/impact" element={<ProtectedRoute><CompanyImpactStrategy /></ProtectedRoute>} />
              <Route path="/company/programme/create/measure" element={<ProtectedRoute><CompanyMeasuringImpact /></ProtectedRoute>} />
              <Route path="/company/programme/create/approval" element={<ProtectedRoute><CompanyMeasuringApproval /></ProtectedRoute>} />
              <Route path="/company/programme/create/admin" element={<ProtectedRoute><CompanyCreateAdmin /></ProtectedRoute>} />
              <Route path="/company/programme/create/preview" element={<ProtectedRoute><CompanyCreatePreview /></ProtectedRoute>} />
              <Route path="/impact-maker/programme/:programID?" element={<ProtectedRoute><CharityApplicationCreatePreview /></ProtectedRoute>} />
              <Route path="/impact-maker/discover" element={<ProtectedRoute><CharityDiscoverFundingOpportunities /></ProtectedRoute>} />
              <Route path="/impact-maker/applications/:programID?/:opportunityID?" element={<ProtectedRoute><CharityProgramReviewTab /></ProtectedRoute>} />
              <Route path="/impact-maker/profile/create/start" element={<ProtectedRoute><CharityProfileCreateStart /></ProtectedRoute>} />
              <Route path="/impact-maker/profile/create/entity-name" element={<ProtectedRoute><CharityEntityName /></ProtectedRoute>} />
              <Route path="/impact-maker/profile/create/legal-structure" element={<ProtectedRoute><CharityProfileLegalStructure /></ProtectedRoute>} />
              <Route path="/impact-maker/content" element={<ProtectedRoute><CharityContent /></ProtectedRoute>} />
              <Route path="/company/content" element={<ProtectedRoute><CompanyContent /></ProtectedRoute>} />
              <Route path="/impact-maker/profile/create/trustees" element={<ProtectedRoute><CharityProfileTrustees /></ProtectedRoute>} />
              <Route path="/impact-maker/profile/create/locations" element={<ProtectedRoute><CharityProfileLocations /></ProtectedRoute>} />
              <Route path="/impact-maker/profile/create/description" element={<ProtectedRoute><CharityProfileDescription /></ProtectedRoute>} />
              <Route path="/impact-maker/profile/create/media" element={<ProtectedRoute><CharityProfileMedia /></ProtectedRoute>} />
              <Route path="/impact-maker/profile/create/preview" element={<ProtectedRoute><CharityProfilePreview /></ProtectedRoute>} />
              <Route path="/impact-maker/profile" element={<ProtectedRoute><CharityProfileReview /></ProtectedRoute>} />
              <Route path="/impact-maker/profile/create/profile-end" element={<ProtectedRoute><CharityProfileEnd /></ProtectedRoute>} />
              <Route path="/impact-maker/content/interim/start/:ID?" element={<ProtectedRoute><CharityInterimCreateStart /></ProtectedRoute>} />
              <Route path="/impact-maker/content/interim/report/:ID?" element={<ProtectedRoute><CharityInterimCreateReport /></ProtectedRoute>} />
              <Route path="/impact-maker/content/interim/preview/:ID?" element={<ProtectedRoute><CharityInterimCreatePreview /></ProtectedRoute>} />
              <Route path="/impact-maker/content/final/start/:ID?" element={<ProtectedRoute><CharityFinalCreateStart /></ProtectedRoute>} />
              <Route path="/impact-maker/content/final/inputs/:ID?" element={<ProtectedRoute><CharityFinalCreateInput /></ProtectedRoute>} />
              <Route path="/impact-maker/content/final/outputs/:ID?" element={<ProtectedRoute><CharityFinalCreateOutput /></ProtectedRoute>} />
              <Route path="/impact-maker/content/final/beneficiaries/:ID?" element={<ProtectedRoute><CharityFinalCreateBeneficiary /></ProtectedRoute>} />
              <Route path="/impact-maker/content/final/objectives/:ID?" element={<ProtectedRoute><CharityFinalCreateObjectives /></ProtectedRoute>} />
              <Route path="/impact-maker/content/final/indicators/:ID?" element={<ProtectedRoute><CharityFinalCreateImpactMeasures /></ProtectedRoute>} />
              <Route path="/impact-maker/content/final/case-studies/:ID?" element={<ProtectedRoute><CharityFinalCaseStudies /></ProtectedRoute>} />
              <Route path="/impact-maker/content/final/next-steps/:ID?" element={<ProtectedRoute><CharityFinalNextSteps /></ProtectedRoute>} />
              <Route path="/impact-maker/content/final/additional-questions/:ID?" element={<ProtectedRoute><CharityFinalAdditionalQuestions /></ProtectedRoute>} />
              <Route path="/company/donations/:programID?/:opportunityID?" element={<ProtectedRoute><CompanyDonation /></ProtectedRoute>} />
              <Route path="/impact-maker/content/final/preview/:ID?" element={<ProtectedRoute><CharityFinalPreview /></ProtectedRoute>} />
              <Route path="/impact-maker/content/:ID?" element={<ProtectedRoute>{type === 'final' ? <CharityFinalReview /> : <CharityInterimCreateReview />}</ProtectedRoute>} />
              <Route path="/company/content/:ID?" element={<ProtectedRoute>{type === 'final' ? <CharityFinalReview /> : <CharityInterimCreateReview />}</ProtectedRoute>} />
              <Route path="/public/:programmeURLCode" element={<CharityApplicationCreatePreview />} />
              <Route path="/share/verification/:uniqueKey?" element={<VerificationComponent />} />
              <Route path="/impact-maker/users" element={<CharityUser />} />
              <Route path="/share/confirmation" element={<ConfirmationComponent />} />
              <Route path="/forgot-password/:email?" element={<ForgetPassword />} />
              <Route path="/share/preapproved/:uniqueKey?/:linkExpiryKey?/:progId?/:email?/:accessCode?" element={<SharePreApproved />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </StyledMainContainer>
        </Container>
      </ConfigProvider>
    </>
  );
};

const BaseRoutes = ({ userType }) => {
  return (
    <Router>
      <RootRoute userType={userType} />
    </Router>
  );
};

export default BaseRoutes;